/**
 * Utilities module barrel file.
 *
 * Provides shared utility functions for common operations.
 *
 * @module utils
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// cn() utility function (moved from utils.ts to barrel file)
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Async helpers
export * from './async-helpers';

// Content utilities (shared by blog, guides, templates)
export * from './content-utils';

// Date utilities
export * from './date';

// Error handling
export * from './error-handling';
export * from './error-utils';

// Icon mapping
export * from './icon-mapper';

// Message utilities
export * from './message-filters';
export * from './message-status';

// Retry utilities
export * from './retry';

// Score validation
export * from './score-validation';

// Security utilities
export * from './security';

// Sender stats
export * from './sender-stats';

// Promise utilities
export * from './promise';

// Sleep utility
export * from './sleep';

// Static assets
export * from './static-assets';

// Subscription utilities
export * from './subscription';

// Toast utilities
export * from './toast-utils';

// URL utilities
export * from './url';

// XML utilities
export * from './xml';
